import type {
  DeleteClientRequest,
  DeleteClientResponse,
  RenameClientRequest,
  RenameClientResponse,
} from "@scoach/types";

import { api } from "../../lib/http.ts";

export const clientsApi = {
  rename: (body: RenameClientRequest) =>
    api<RenameClientResponse>("/api/clients/rename", { method: "PATCH", body }),

  remove: (body: DeleteClientRequest) =>
    api<DeleteClientResponse>("/api/clients/delete", { method: "POST", body }),
};
